import { useRef, FormEvent, FC, useState, useEffect } from "react";
import { OldApi } from "../api/api";
import { IVacancy } from "../utils/types";
import { useTranslation } from "react-i18next";

interface IPopupAccessProps {
  position: string;
  onClose: () => void;
}

const PopupAccess: FC<IPopupAccessProps> = ({ onClose, position }) => {
  const { t } = useTranslation();

  const handleBackgroundClick = (e: any) => {
    if (e.target.className === "popup") {
      onClose();
    }
  };

  useEffect(() => {
    document.ontouchmove = (event) => {
      // @ts-ignore
      if (event.target.className === "popup-content") {
        if (event.touches.length === 1) {
          event.preventDefault();
        }
      }
    };
    document.body.style.overflow = "hidden";
    return () => {
      document.ontouchmove = (event) => {
        event.stopPropagation();
        event.stopImmediatePropagation();
      };
      document.body.style.overflow = "initial";
    };
  }, []);

  return (
    <div className="popup-wrapper" onClick={handleBackgroundClick}>
      <input type="checkbox" className="popup-checkbox" id="popupCheckboxOne" />
      <div className="popup">
        <div className="popup-content popup-content-access">
          <label
            htmlFor="popupCheckboxOne"
            className="popup-closer"
            onClick={onClose}
          >
            &#215;
          </label>
          <h4 className="popup-content-access-title">
            {t("vacancies:successfullyApplied")}:
          </h4>
          <p className="popup-content-access-text">{position}</p>
          <div className="btn">
            <button className="btn1" onClick={onClose}>
              {t("vacancies:close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupAccess;
